import React, { Suspense, useState } from 'react';
import Section from './Section'; // Assuming this is a layout or wrapper component
import { twMerge } from 'tailwind-merge';
import { DefaultContent, ImageMedia, VideoShort } from '../imports';

const Gallery = ({ vertical, resp, fill, defaultSize, title, content, className, ...props }) => {


  const [activeSize, setActiveSize] = useState(defaultSize ? "Contenir" : 'Remplir');
  const [size, setSize] = useState({ gallery: "", content: activeSize })
  const resizeButtons = [
    { label: "Remplir", onClick: () => { setActiveSize('Remplir'); setSize({ content: 'object-cover w-[100%] !quick' }) }, icon: "ri-fullscreen-line" },
    { label: "Contenir", onClick: () => { setActiveSize('Contenir'); setSize({ content: 'object-contain w-full !quick' }) }, icon: "ri-fullscreen-exit-line" },// 
  ]
  const [displayed, setDisplayed] = useState({ src: (content && content.length) ? content[0].src : null, key: null, type: "image" })



  const renderImage = (src, key) => (
    <div onClick={() => displayed.src !== src && setDisplayed({ src: src, key: key, type: "image" })} className={twMerge('relative flex full center')}>
      <ImageMedia key={key} loading="eager" src={src} alt={`Gallery content ${key}`} className={`!quick w-full h-full ${size.content}`} />
    </div>
  );

  const renderVideo = (src, key) => (
    <div onClick={() => displayed.src !== src && setDisplayed({ src: src, key: key, type: "video" })} className='relative flex full center'>
      <VideoShort key={key} src={src} controls className="full object-cover" />
    </div>
  );

  const RenderContent = (item, key) => {
    switch (item.type) {
      case 'image':
        return renderImage(item.src, key);
      case 'video':
        return renderVideo(item.src, key);
      default:
        return renderImage(item.src, key);
    }
  };

  /*  useEffect(() => {
     const intervalId = setInterval(() => {
       setDisplayed((prevDisplayed) => {
         const nextIndex = (content.findIndex(item => item.src === prevDisplayed.src) + 1) % content.length;
         const nextItem = content[nextIndex];
         return { src: nextItem.src, key: nextItem.key, type: nextItem.type };
       });
     }, 5000);
 
     return () => clearInterval(intervalId);
   }, [content, displayed]); */

  return (
    <Section padded key={title} id="gallery" className={twMerge('bg-transparent relative w-full ', resp && "resp", className)} {...props}>
      {/* {title && <h2 className="text-2xl font-semibold mb-4">{title}</h2>} */}

      <div className={twMerge('flex flex-col relative gap-4 max-h-[100svh] h-full bg paddingY= w-full', vertical && "!flex-row", fill ? "w-full" : "w-fit=")}>
        {/* DISPLAY */}
        <div className="flex relative min-w-[50vw] flex-1 center min-h-[80vh] h-full max-h-[95svh] w-full">
          {content && content.length && displayed.src
            ?
            <Suspense fallback={<DefaultContent className={"absolute inset-0"} />}>
              <div className='flex h-full w-full relative center min-w-[100%] center min-h-[80svh]  overflow-clip group '>
                <div className={twMerge('absolute inset-0 =hover:scale-105 quick flex items-end justify-center border border1 bg-black/5',
                  size.content
                )}>
                  {RenderContent({ type: displayed.type, src: displayed.src })}
                </div>
              </div>
            </Suspense>
            :
            <DefaultContent className={"absolute inset-0"} />
          }
          {/* TOGGLE FILL */}
          <div className='absolute === mx-auto bottom-4 w-fit flex center'>
            <div className='relative flex w-12 h-12 center rounded-full overflow-hidden'>
              {resizeButtons.map((button, i) => {
                return (
                  <button key={button.label + i} onClick={() => button.onClick()} className={twMerge("absolute inset-0 flex center size-12 =group-hover:-translate-y-4 quicker hover:bg-white px-2 hover:text-black bg-white/10", activeSize === button.label && "opacity-0 origin-bottom scale-0 quicker")}>
                    <i className={`ri-md ${button.icon} flex center size-12`} />
                  </button>
                )
              })}
            </div>
          </div>
        </div>

        {/* ITEMS */}
        <div className={twMerge("grid grid-cols-6 py-6 lg:flex flex-row flex-wrap items-center justify-center overflow-x-scroll relative w-full h-full mx-auto overflow-auto gap-x-4 gap-y-6 group paddingX quicker", vertical && "flex flex-col nowrap w-fit",
          content.length > 12 && "!justify-start"
        )}>
          {content && content.length ? content.map((item, index) => (
            <div key={index} className={twMerge('flex center min-w-14= !size-[56px] *:overflow-hidden =w-fit *:aspect-square aspect-auto====mx-auto relative group-hover:brightness-75 hover:!brightness-100 border cursor-pointer border1 quick *:!object-cover', displayed.src === item.src && " brightness-100")}>
              <RenderContent key={index} {...item} />
              {displayed.src === item.src &&
                <div style={{ bottom: -15 }} className='flex absolute bottom-0 size-2 animate-slidedown !quicker bg-white rounded-full' />
              }
            </div>
          ))
            :
            <h4>Cette galerie n'a pas de contenu :(</h4>
          }
        </div>
      </div>
    </Section>
  );
};

export default Gallery;
